import React from 'react'

import Icon from '../../../../Shared/Icon/Icon'

function ProductAnalyticsTierCompleted() {
  return (
    <div className="tier-completed">
      <Icon type={['fal', 'check-circle']} color="green-dark" className="is-completed" />
      <h4 className="tier-completed__title">Complete!</h4>
    </div>
  )
}

export default ProductAnalyticsTierCompleted
